module.exports = __webpack_public_path__ + "static/media/metalSonic.35571159.gif";